Ext.define('SA.HistogramController', {
    extend: 'SA.ViewController',

    constructor(model) {
        this.callParent([model]);

        this.sidebarHandlers = {
            data: this.onSidebarUseAttribute.bind(this),
            locations: this.onSidebarUseLocation.bind(this)
        };
    },

    createDefaultView() {
        var view = Ext.widget({xtype: 'histogram-view'}),
            projectView = SA.ProjectView.createHidden(view),
            modeState = SA.ViewControllerModeState.forViewMode({controller: this});

        this.toolbar = new SA.HistogramToolbar({model: this.model});
        this.projectViews.set('view', projectView);

        new SA.HistogramViewController({modeState, model: this.model, toolbar: this.toolbar, view, projectView});

        return projectView;
    },

    createEditView() {
        this.editController = new SA.HistogramEditController(this.getEditControllerParams());

        return SA.ProjectView.createHidden(this.editController.getView());
    },

    onActive() {
        SA.SidebarState.create()
            .enableTabs(['locations', 'data'])
            .selectTab(SA.Sidebar.lastClickedLocationsTab() ? 'locations' : 'data')
            .setModel(this.model)
            .setHandlers(this.sidebarHandlers)
            .apply();
    },

    onSidebarUseAttribute(attribute) {
        this.model.getProject().addAttribute(attribute);
        this.model.setData({attribute});

        SA.data.RecentAttributes.add(attribute);

        if (this.isEditMode()) {
            this.editController.onSidebarUseAttribute(attribute);
        }
    },

    onSidebarUseLocation(location) {
        if (!this.model.supportsLocation(location)) {
            Ext.widget({xtype: 'histogram-cannot-select-location-popup', location});
            return;
        }

        this.model.getProject().addLocation(location);
        this.model.setData({location});

        SA.data.RecentLocations.add(location);

        if (this.isEditMode()) {
            this.editController.onSidebarUseLocation(location);
        }
    }
});